import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
  TableCell,
  TableRow,
} from "@material-ui/core";
//import { useForm } from "react-hook-form";
import { AuthContext } from "../context";
import { laboratoryServices, operatorServices } from "../services";
import {
  SimpleToolbar,
  Loader,
  PatientAssign,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { useDrawer } from "../hooks";
import moment from "moment";
import { handleDownloadExcel, getAssignmentStatusNames } from "../helpers";
const tableHeader = [
  "Productos",
  "Operador",
  "Médico",
  "RUT Médico",
  "Fecha de Asignación",
  "Estatus",
];
export default function AssignToOperatorScreen(props) {
  const classes = useStyles();
  const [assignments, setAssignments] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [operator, setOperator] = useState(null);
  const { isOpen, setIsOpen } = useDrawer();
  const [allAssignmentsToExport, setAllAssignmentsToExport] = useState([]);
  const tableBody = useRef([]);

  useEffect(() => {
    const tableData = assignments.map((assignment) => {
      return [
        "",
        operator.name || "",
        `${assignment.doctor.name || ""} ${assignment.doctor.lastName || ""}`,
        assignment.doctor.rut || "",
        moment(assignment?.createdAt).format("DD/MM/YYYY hh:mm a"),
        getAssignmentStatusNames(assignment.status),
      ];
    });
    tableBody.current = tableData;
  }, [assignments]);

  useEffect(() => {
    setReload(false);
    async function getAssignments() {
      try {
        setLoading(true);
        const { status, response } =
          await laboratoryServices.getPatientAssignProduct({
            laboratoryId: authState.user.laboratory._id,
            page,
            limit,
            token: authState.token,
            text: "",
          });

        const {
          response: { assigments: allAssignments },
        } = await laboratoryServices.getPatientAssignProduct({
          laboratoryId: authState.user.laboratory._id,
          page: 1,
          limit: response.total,
          token: authState.token,
          text: "",
        });
        setAllAssignmentsToExport(allAssignments);
        setLoading(false);
        if (status === 200) {
          setAssignments(response.assigments);
          setLimit(response.limit);
          setCount(response.total);
          setPage(response.page);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
    getAssignments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState, reload, signOut]);

  useEffect(() => {
    async function getOperator() {
      try {
        setLoading(true);
        const { status, response } = await operatorServices.findByLaboratory({
          token: authState.token,
          id:
            authState.user.role.name === "USER_LABORATORY"
              ? authState.user.laboratory.laboratoryId
              : authState.user.laboratory._id,
          isLaboratoryChield:
            authState.user.role.name === "USER_LABORATORY" ? true : false,
        });
        setLoading(false);
        if (status === 200) {
          setOperator(response.operator);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
    getOperator();
  }, [authState, signOut]);

  const getAssignmentsFilter = async (text) => {
    try {
      setLoading(true);
      const { status, response } =
        await laboratoryServices.getPatientAssignProduct({
          laboratoryId: authState.user.laboratory._id,
          page,
          limit,
          token: authState.token,
          text,
        });
      setLoading(false);
      if (status === 200) {
        setAssignments(response.assigments);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const optionsToolbar = [
    {
      label: "Export excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Asignaciones pendientes",
          tableHeader: tableHeader,
          tableBody: tableBody.current,
        });
      },
    },
  ];
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            <Container maxWidth={false}>
              <SimpleToolbar
                reload={() => setReload(true)}
                onFilter={(text) => getAssignmentsFilter(text)}
                // table={"pendingAssignmentsTable"}
                // filename={"Asignaciones pendientes"}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                // tableHeader={tableHeader}
                // tableBody={tableBody}
                options={optionsToolbar}
              />
              <BaseTable>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Productos</StyledTableCell>
                    <StyledTableCell>Operador</StyledTableCell>
                    <StyledTableCell>Médico</StyledTableCell>
                    <StyledTableCell>Rut Médico</StyledTableCell>
                    <StyledTableCell>Fecha de Asignación</StyledTableCell>
                    <StyledTableCell>Estatus</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {assignments.map((assignment, index) => (
                    <PatientAssign
                      index={index}
                      assignment={assignment}
                      operator={operator}
                      onClickAssign={() => {}}
                      isLab
                    />
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(e.target.value);
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>

      <div style={{ display: "none" }}>
        <BaseTable tableId="pendingAssignmentsTable">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Medico</StyledTableCell>
              <StyledTableCell>Rut</StyledTableCell>
              <StyledTableCell>Creacion</StyledTableCell>
              <StyledTableCell>Ultimo estatus</StyledTableCell>
              <StyledTableCell>Producto</StyledTableCell>
              <StyledTableCell>Localizador</StyledTableCell>
              <StyledTableCell>Estatus</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {allAssignmentsToExport?.map((assignment, index) => {
              const {
                _id,
                rut,
                firstName,
                lastName,
                email,
                phone,
                status,
                address,
                createdAt,
                updatedAt,
                doctor,
                products,
              } = assignment;

              const ndc = new Date(createdAt).getTime();
              const ndu = new Date(updatedAt).getTime();
              const date_broken = ndc > ndu;
              return (
                <TableRow>
                  <TableCell>{`${doctor?.name} ${doctor?.lastName}`}</TableCell>
                  <TableCell>{`${doctor?.rut}`}</TableCell>
                  <TableCell>{`${new Date(
                    createdAt
                  ).toLocaleString()}`}</TableCell>
                  <TableCell>{`${
                    date_broken ? "N/A" : new Date(updatedAt).toLocaleString()
                  }`}</TableCell>
                  <TableCell>{`${products[0].name}`}</TableCell>
                  <TableCell>{`${"N/A"}`}</TableCell>
                  <TableCell>{`${
                    status === 0
                      ? "En espera por aprobación del paciente"
                      : status === 1
                      ? "Entregada"
                      : status === 2
                      ? "Fallida en entrega"
                      : status === 3
                      ? "En camino"
                      : "Rechazada por el paciente"
                  }`}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </BaseTable>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  form: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    width: "100%",
  },
  btnCancel: {
    backgroundColor: theme.palette.secondary.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  btnConfirm: {
    backgroundColor: theme.palette.primary.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#f44336",
  },
  dialogTitle: {
    textAlign: "Center",
  },
  shrinkLabel: {
    "& > label:nth-child(1)": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
    "& > div:nth-child(2)": {
      "& > fieldset": {
        "& > legend": {
          maxWidth: 1000,
        },
      },
    },
  },
  formControl: {
    width: "100%",
    minWidth: 120,
  },
}));
